import React, { useEffect, useState } from "react";
import manitou from "../../assets/images/manitougroup.png";
import { Navigation } from "../navigation/navigation";
import { useLocation } from "react-router-dom";
import "./header.css";
import { useOktaAuth } from "@okta/okta-react";

/**
 * @function Header displays the header of the website with or without the navigation bar or the burger menu
 * @returns {JSX.Element} HTML content
 */
function Header() {

  const [display, setDisplay] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDisplay(false);
  }, [location]);

  const { oktaAuth } = useOktaAuth();

  const handleLogout = async () => {
    try {
      const redirectUri = window.location.origin;
      await oktaAuth.signOut({
        postLogoutRedirectUri: redirectUri + '/Account/PostLogout'
      });
    } catch (error) {
      console.error('Erreur lors de la tentative de connexion:', error);
    }

  };

  /* is the user connected or not */
  return (
    <>
      <div className="container header">
        <div className="flex justify-between items-center py-2 px-3 bg-white">
          <div className="flex items-center">
            <img
              className="max-h-12 place-self-center pl-2 md:pl-0 md:max-h-10 lg:self-end"
              src={manitou}
            />
            <h1 className="ml-4 font-black text-base lg:text-xl">
              CoWorking MANITOU Group
            </h1>
          </div>
          <div className="flex items-center">
            <div className="relative sm:flex hidden">
              <button onClick={() => void handleLogout()} className="Logout">
                Se déconnecter
              </button>
            </div>
            {display ? (
              <button className="ml-2 sm:hidden">
                <span
                  className="material-icons burger align-middle"
                  onClick={() => setDisplay(false)}
                >
                  close
                </span>
              </button>
            ) : (
              <button className="ml-2 sm:hidden">
                <span
                  className="material-icons burger align-middle"
                  onClick={() => setDisplay(true)}
                >
                  menu
                </span>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* call of Navigation to display the burger menu, the navigation bar and activate the routing system */}
      <Navigation open={display} />
    </>
  );
}


export { Header };


